import React, { useMemo } from "react";

import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { SxProps, useTheme } from "@mui/material/styles";

import { OnboardingRequest } from "services/types/onboarding-request.type";

interface IntakeFormsCountProps {
  patientId: number;
  form: OnboardingRequest;
  sx?: SxProps;
}

const IntakeFormsCount: React.FC<IntakeFormsCountProps> = ({
  patientId,
  form
}) => {
  const { palette } = useTheme();

  const requestedCount = form?.forms_requested_count;
  const submittedCount = form?.forms_submitted_count;

  const backgroundColor = useMemo(() => {
    if (submittedCount === requestedCount) {
      return palette.success.light;
    }

    if (submittedCount === 0) {
      return palette.error.light;
    }

    return palette.warning.light;
  }, [submittedCount, requestedCount, palette]);

  return requestedCount ? (
    <Link
      href={`/patients/${patientId}/profile/onboardings`}
      target="_blank"
      underline="none"
      sx={{ color: "unset !important" }}
    >
      <Typography
        p={0.5}
        m={-0.5}
        borderRadius={0.5}
        sx={{ backgroundColor }}
      >{`${submittedCount}/${requestedCount} Intake Forms Submitted`}</Typography>
    </Link>
  ) : null;
};

export default IntakeFormsCount;
